import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})

export class ContextService {

  public contexts: any = [];

  constructor (
    private db: AngularFirestore,
  ) { }

  async loadContexts (congress: boolean): Promise<any[]> {
    try {
      const querySnapshot = await this.db.collection<any>('sbccv_contexts', ref => ref
        .where("congress", "==", congress)
        .orderBy("name", "desc"))
        .get()
        .toPromise();
      const array: any[] = [];
      querySnapshot.forEach((item) => {
        array.push({
          "id": item.data().id,
          "name": item.data().name,
          "congress": item.data().congress
        });
      });
      array.sort(this.compareContexts)
      // console.log(JSON.stringify(array))
      return array;
    } catch (error) {
      console.error("Erro loadContexts: ", error);
      throw error;
    }
  }

  async loadAllContexts (): Promise<any[]> {
    try {
      const querySnapshot = await this.db.collection<any>('sbccv_contexts', ref => ref
        .orderBy("name", "desc"))
        .get()
        .toPromise();
      const array: any[] = [];
      querySnapshot.forEach(async (item) => {
        array.push({
          "id": item.data().id,
          "name": item.data().name,
          "congress": item.data().congress
        });
      });
      console.log("loadAllContexts: " + JSON.stringify(array))

      return array;
    } catch (error) {
      console.error("Erro loadAllContexts: ", error);
      throw error;
    }
  }

  async getMasterEvent (context_id: any) {
    try {
      return this.db.collection<Event>('sbccv_events', ref => ref
        .where('context_id', '==', context_id)
        .where('master', '==', true)
        .limit(1))
        .get()
        .toPromise()
        .then(async (result) => {
          return {
            "id": result.docs[ 0 ].id,
            ...result.docs[ 0 ].data()
          }
        })
    } catch (error) {
      console.error("Erro getMasterEvent: ", error);
      throw error;
    }
  }

  async getEvent (event_id: any) {
    // console.log("getEvent event_id: " + event_id)
    try {
      return this.db.doc<Event>('sbccv_events/' + event_id)
        .get()
        .toPromise()
        .then(async (result) => {
          return {
            ...result.data(),
             "id": result.id
          }
        })
    } catch (error) {
      console.error("Erro getEvent: ", error);
      throw error;
    }
  }

  compareContexts (a: any, b: any) {

    const pa = String(a.name)
    const pb = String(b.name)

    if (pa < pb) return 1;
    if (pb < pa) return -1;
    return 0;

  }

  async getEventsInContext (isCongress: boolean, context_id: string): Promise<any[]> {
    const array: any[] = [];
    try {
      if (!isCongress) {
        return [ context_id ];
      }
      const querySnapshot = await this.db.collection<any>('sbccv_events', ref => ref
        .where("context_id", "==", context_id))
        .get()
        .toPromise();

      querySnapshot.forEach(async (doc) => {
        // Adiciona cada documento ao array
        array.push(doc.id);
      });
      // Retorna o array após carregado
      return array;
    } catch (error) {
      console.error("Erro getEventsInContext: ", error);
      throw error;
    }
  }

  async getEventsWithCertificatesInContext (context_id: string): Promise<any[]> {
    //console.log("context_id: " + context_id)
    const array: any[] = [];
    try {
      const querySnapshot = await this.db.collection<any>('sbccv_events', ref => ref
        .where("context_id", "==", context_id)
        .where("belongsToProduct", "==", true))
        .get()
        .toPromise();

      querySnapshot.forEach(async (doc) => {
        // Adiciona cada documento ao array
        array.push({
          "id": doc.id,
          "name": doc.data().name
        });
      });
      // Retorna o array após carregado
      return array;
    } catch (error) {
      console.error("Erro getEventsInContext: ", error);
      throw error;
    }
  }

  async selectProductsByEvents (events: any[]): Promise<any[]> {
    //  console.log("getProductsByEvents: " + JSON.stringify(events))
    try {

      const array: any[] = [];

      for (const event of events) {

        let currEvt: any;

        currEvt = array.find((e: any) => {
          return e.id == event.id
        })

        if (!currEvt) {
          currEvt = {
            "id": event.id,
            "name": event.name,
            "products": []
          }
          array.push(currEvt)
        }

        const querySnapshot = await this.db.collection<any>('sbccv_product_itens', ref => ref
          .where('event_id', '==', event.id))
          .get()
          .toPromise();

        querySnapshot.forEach(doc => {
          currEvt.products.push(doc.data().product_id)
          // console.log("doc.id: " + doc.id)
          /*
          const data: any = {
            "product_id": doc.data().product_id,
            "event_name": event.name, //doc.data().event_name,
            "event_id": event.id, //doc.data().event_id
          }
          array.push(data);
          */
        });
      }
      return array;
      //
    } catch (error) {
      console.error(`Erro ao buscar produtos para eventos `, error);
    }


  }

  async _selectProductsByEvents (events: any[]): Promise<any[]> {
    // console.log("getProductsByEvents: " + JSON.stringify(events))
    try {

      const array: any[] = [];

      for (const event of events) {

        let currEvt: any;

        currEvt = array.find((e) => {
          return e.id == event.id
        })

        if (!currEvt) {
          currEvt = {
            "id": event.id,
            "name": event.name,
            "products": []
          }
        }

        const querySnapshot = await this.db.collection<any>('sbccv_product_itens', ref => ref
          .where('event_id', '==', event.id))
          .get()
          .toPromise();


        querySnapshot.forEach(doc => {
          // console.log("doc.id: " + doc.id)
          const data: any = {
            "product_id": doc.data().product_id,
            "event_name": event.name, //doc.data().event_name,
            "event_id": event.id, //doc.data().event_id
          }
          array.push(data);
        });
      }
      return array;
      //
    } catch (error) {
      console.error(`Erro ao buscar produtos para eventos `, error);
    }


  }
  /*

  getContexts () {
    this.contexts = [];

    return this.db.collection<any>('sbccv_events', ref => ref
      .where("congress", "==", true))
      .snapshotChanges()
      .subscribe((result) => {
        result.forEach((item) => {
          const ctx = item.payload.doc.data().context_id ? item.payload.doc.data().context_id : null;
          if (ctx) {
            const existCtx = this.contexts.find((e) => {
              return e == ctx
            })
            if (!existCtx) {
              this.contexts.push(ctx);
            }
          }
        })

        this.contexts.sort(this.compareContexts)

      });
  }

  _select (isCongress: boolean) {
    return this.db.collection<any>('sbccv_events', ref => ref
      .where("congress", "==", isCongress))
      .snapshotChanges();
  }
  */
}
